import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ListItemButton from "@mui/material/ListItemButton";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: theme.spacing(1.25),
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingRight: theme.spacing(1),
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  minHeight: 320,
  maxHeight: "70vh",
}));

export const SearchField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  "& .MuiInputBase-input::placeholder": {
    color: theme.palette.grey[500],
    opacity: 1,
  },
}));

export const CurrentValueText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

export const TreeScrollBox = styled(Box)(({ theme }) => ({
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: theme.palette.divider,
  borderRadius: theme.spacing(1),
  maxHeight: 360,
  overflow: "auto",
}));

export const EmptyTreeText = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(2),
  color: theme.palette.text.secondary,
}));

export const TreeRowOuter = styled(Box, {
  shouldForwardProp: (p) => p !== "$depth",
})(({ theme, $depth = 0 }) => ({
  display: "flex",
  alignItems: "stretch",
  paddingLeft: theme.spacing($depth * 2),
}));

export const TreeIndent = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  width: 40,
  flexShrink: 0,
  justifyContent: "center",
}));

export const TreeSpacer = styled(Box)({
  width: 40,
});

export const TreeListItemButton = styled(ListItemButton)(({ theme }) => ({
  flex: 1,
  paddingTop: theme.spacing(0.75),
  paddingBottom: theme.spacing(0.75),
}));

export const HintText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

export const TreeBranchRoot = styled(Box)({});
